/**
 * CockpitResponse
 * @author ftgibran
 */
import {$, ID, Model, Resource} from 'simpli-web-sdk'
import DeliveryShipperResponseSchema from '@/schema/DeliveryShipperResponse.schema.ts'

export default class DeliveryShipperResponse extends Resource {
  readonly $name: string = 'DeliveryShipperResponse'
  readonly $endpoint: string = '/user/indicador/entrega-por-embarcador'

  get $schema() {
    return DeliveryShipperResponseSchema(this)
  }

  $id = 0
  nome: string | null = null
  qtdTotal: number | null = null
  qtdSemOcorrencia: number | null  = null
  qtdComOcorrencia: number | null  = null
  qtdDevolvidas: number | null  = null
  documento: string | null = null

}
